/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboxMessageDelete
 */
export interface InboxMessageDelete {
    /**
     * 
     * @type {string}
     * @memberof InboxMessageDelete
     */
    id: string;
}

/**
 * Check if a given object implements the InboxMessageDelete interface.
 */
export function instanceOfInboxMessageDelete(value: object): value is InboxMessageDelete {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InboxMessageDeleteFromJSON(json: any): InboxMessageDelete {
    return InboxMessageDeleteFromJSONTyped(json, false);
}

export function InboxMessageDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxMessageDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function InboxMessageDeleteToJSON(json: any): InboxMessageDelete {
    return InboxMessageDeleteToJSONTyped(json, false);
}

export function InboxMessageDeleteToJSONTyped(value?: InboxMessageDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

